export default __webpack_public_path__ + "static/media/Opera Mini.d6ebb0cc.svg";